import { COLOR_KEYS } from '../../../constants';
import { TestimonialsSectionProps } from './TestimonialsSection';

export const DEFAULT_VALUES: TestimonialsSectionProps = {
  backgroundColor: COLOR_KEYS.night,
  ctaText: 'Meet our customers',
  ctaUrl: '#',
  description:
    '<p>Success starts with a Zap. At least that’s how these folks started. Maybe we’ll share your tweet next.</p>',
  heading: 'Automation does the business good',
  testimonials: new Array(4).fill({
    author: 'Name, VP of marketing at Storycorp',
    logoAltText: 'StoryCorps',
    logoUrl: 'https://cdn.zappy.app/4829b5157622c5c9bf800050cb265573.png',
    quote:
      '<p>“We uses Zapier to enrich our CRM data and improve internal workflows”</p>',
    thumbnailAltText: '32% increase in leads triaged',
    thumbnailUrl: 'https://cdn.zappy.app/a6614085a15dac866830d02221ab7900.png',
  }),
};
